module.exports = __webpack_public_path__ + "static/media/EasyWords_ios_3.02c7d984.jpg";